import {
  ChevronDownIcon as ChevronDownDs,
  CloseIcon as CloseDs
} from "../Icons";
import { Typography } from "../Typography";
import styled, { css } from "styled-components";

import { Button } from "../Button";

import type { ExpandableRowProps } from "./types";

export const ChevronDown = styled(ChevronDownDs)`
  fill: currentColor;
`;

export const Close = styled(CloseDs)`
  fill: currentColor;
`;

export const Wrapper = styled.div<{
  disableBoxShadow: boolean;
  isOpen: boolean;
  variant: ExpandableRowProps["variant"];
}>`
  margin-bottom: ${({ variant }) => (variant === "short" ? "8px" : "4px")};
  border-radius: 4px;
  background-color: var(--mode-bg-neutral-weakest);

  ${({ isOpen, disableBoxShadow }) =>
    isOpen &&
    css`
      margin: 0 0 4px 0;
      background-color: var(--mode-bg-neutral-weakest);
      box-shadow: ${props =>
        disableBoxShadow
          ? "none"
          : props.theme.name === "dark"
            ? "0px 6px 44px #01001A"
            : "0px 10px 20px rgba(75, 97, 128, 0.08)"};
    `}
`;

export const OpenText = styled(Typography.BodyText)<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? "none" : "inline")};
  opacity: 0;
  color: currentColor;
  margin-bottom: 0 !important;
  &:first-letter {
    text-transform: uppercase;
  }
`;

export const StyledButton = styled(Button)`
  background: transparent;
  color: var(var(--mode-text-neutral-default-weak));
  &:hover,
  &:focus {
    background: transparent;
    color: var(--mode-text-primary-default);

    ${OpenText} {
      opacity: 1;
    }
  }
`;

const __layout_mobile = css`
  padding: 0 24px;

  @media (min-width: 768px) {
    padding: 0 32px;
  }
`;

const __layout_open_hover = css`
  background-color: var(--mode-bg-neutral-weaker);
  box-shadow: none;
`;

const __layout_closed_hover = css`
  background-color: var(--mode-bg-neutral-weakest);

  box-shadow: ${props =>
    props.theme.name === "dark"
      ? "0px 6px 44px #01001A"
      : "0px 10px 20px rgba(75, 97, 128, 0.08)"};
`;

const __layout_short = css`
  max-height: 32px;
  min-height: 32px;
  padding: 0 15px;
  background-color: var(--mode-bg-neutral-weaker);
`;

const __layout_short_closed_hover = css`
  background-color: var(--mode-bg-neutral-weaker);
`;

const __layout_short_open_hover = css`
  ${__layout_short_closed_hover}
  box-shadow: none;
`;

export const Layout = styled.div<{
  variant: ExpandableRowProps["variant"];
  isOpen: boolean;
}>`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  min-height: 60px;
  box-sizing: border-box;
  border-radius: 4px 4px 0 0;

  ${({ isOpen }) =>
    isOpen &&
    css`
      background-color: var(--mode-bg-neutral-weaker);
    `}

  ${({ variant }) => variant === "mobile" && __layout_mobile};

  ${({ variant }) => variant === "short" && __layout_short};

  &:hover {
    ${({ isOpen, variant }) => {
      if (variant !== "short") {
        return isOpen ? __layout_open_hover : __layout_closed_hover;
      }
    }}

    ${({ isOpen, variant }) => {
      if (variant === "short") {
        return isOpen ? __layout_short_open_hover : __layout_short_closed_hover;
      }
    }}

    ${ChevronDown} {
      fill: currentColor;
    }
  }
`;

export const Info = styled.div<{
  width: ExpandableRowProps["infoWidth"];
}>`
  width: ${props => props.width || "100%"};
`;

export const ActionWrapper = styled.div<{
  isOpen: boolean;
}>`
  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: rotate(180deg);
    `}
`;
